import { RunContextItem } from '../../../store/customWorkflow/customWorkflows'

const humanize = (raw?: string): string => {
  if (!raw) return ''
  const spaced = raw
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
  if (!spaced) return raw
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase()
}

const KIND_LABELS: Record<string, string> = {
  contact: 'Contact',
  ccqExecution: 'Cross-client query',
  meeting: 'Meeting',
}

const AGENT_TYPE_LABELS: Record<string, string> = {
  meetingSummary: 'Meeting summary',
  meetingPreparation: 'Meeting preparation',
  meetingAgenda: 'Meeting agenda',
}

export const contextKindLabel = (item: RunContextItem): string => {
  if (item.kind === 'aiAgentResult') return AGENT_TYPE_LABELS[item.agentType ?? ''] ?? humanize(item.agentType)
  if (item.kind === 'event') return humanize(item.eventType)
  return KIND_LABELS[item.kind] ?? humanize(item.kind)
}

export const primaryContextLabel = (context?: RunContextItem[]): string => (context && context.length > 0 ? contextKindLabel(context[0]) : '')
